<template>
  <div class="login-config">
    <el-form class="config-form" ref="form" :model="form" label-width="170px" label-position="left">
      <div class="config-title">
        <h3>模块配置</h3>
        <p class="config-title-inline"></p>
      </div>
      <el-form-item label="用户Q群功能">
        <el-switch v-model="form.userQQCrowd" active-value="1" inactive-value="2"	></el-switch>
        <span class="tip">说明：开启后，页面将显示"用户Q群模块"</span>
      </el-form-item>
      <el-form-item label="意见反馈模块">
        <el-checkbox-group class="el-checkbox-all" v-model="form.opinion">
          <el-checkbox label="1">功能需求</el-checkbox>
          <el-checkbox label="2">系统问题</el-checkbox>
          <el-checkbox label="3">商务合作</el-checkbox>
        </el-checkbox-group>
        <span class="tip">说明：勾选后，系统将开启意见反馈模块，反馈的类型将是选中的类型</span>
      </el-form-item>
      <el-form-item label="使用需求模块">
        <el-switch v-model="form.demand" active-value="1" inactive-value="2"></el-switch>
        <span class="tip">说明：开启后，系统将显示"使用需求"模块</span>
      </el-form-item>
      <el-form-item label='菜单"关于"模块'>
        <el-switch v-model="form.about" active-value="1" inactive-value="2"></el-switch>
        <span class="tip">说明：开启后，系统将在首页导航条显示"关于"模块</span>
      </el-form-item>
      <div class="config-title">
        <h3>功能配置</h3>
        <p class="config-title-inline"></p>
      </div>
      <el-form-item label="office系列阅读功能">
        <el-switch v-model="form.officeRead" active-value="1" inactive-value="2"></el-switch>
        <span class="tip">说明：工具转换处理完成页面</span>
      </el-form-item>
      <!-- <el-form-item label="工具批量操作配置">
        <el-select v-model="form.batch" filterable size="small" multiple collapse-tags placeholder="请选择">
          <el-option
            v-for="item in toolsOptions"
            :key="item.id"
            :label="item.name"
            :value="item.name">
            {{ item.name }}
          </el-option>
        </el-select>
        <span class="tip">说明：添加的工具，<b class="setcolor">将不支持文件的批量操作</b> </span>
      </el-form-item> -->
      <!-- <el-form-item label="" class="tag-show">
        <el-tag
          v-for="(tag,index) in form.batch"
          :key="index"
          @close="removeToolBatchOperation(tag)"
          closable>
          {{tag}}
        </el-tag>
      </el-form-item> -->
      <div class="config-title">
        <h3>内容配置</h3>
        <p class="config-title-inline"></p>
      </div>
      <el-form-item label="搜索框推荐配置">
        <el-select v-model="form.recommend" filterable size="small" multiple collapse-tags placeholder="请选择">
          <el-option
            v-for="item in toolsOptions"
            :key="item.id"
            :label="item.name"
            :value="item.name">
            {{ item.name }}
          </el-option>
        </el-select>
        <span class="tip">说明：向首页搜索框下添加推荐工， 具建议添加4-6个 </span>
      </el-form-item>
      <el-form-item label="" class="tag-show">
        <el-tag
          v-for="(tag,index) in form.recommend"
          :key="index"
          @close="removeSearchBatchOperation(tag)"
          closable>
          {{tag}}
        </el-tag>
      </el-form-item>
      <el-form-item label="工具banner内容配置" class="config-title-banner">
        <el-input type="textarea" size="small" v-model="form.bannerText"></el-input>
        <span class="tip">说明：自定义工具页banner页面显示内容</span>
      </el-form-item>
      <el-form-item label="首页banner配置" class="config-title-banner">
        <el-col :span="7">
          <el-input type="textarea" size="small" placeholder="请输入首页banner标题配置" v-model="form.homePageTitle"></el-input>
        </el-col>
        <el-col :span="7" style="margin-left: 5px;">
        <el-input type="textarea" size="small" placeholder="请输入首页banner内容配置" v-model="form.homePageContent"></el-input>
        </el-col>
        <span class="tip">说明：自定义首页banner页面显示内容</span>
      </el-form-item>
      <el-form-item class="config-btn">
        <el-button size="small" type="primary" @click="saveLoginType">保存</el-button>
        <el-button  size="small" @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {toolUploadAPI,toolsAPI} from 'liankong-ui-api'  
export default {
  components: {},
  data() {
    return {
      form:{
        userQQCrowd:'',  // 用户QQ群
        // batch:[],  // 工具批量
        bannerText:'', // 首页文字
        about:'',  // 关于我们
        officeRead:'', // office开关
        demand:'',  // 需求文档
        homePageTitle:'', // 首页标题
        homePageContent:'', //首页内容
        opinion:[]  // 意见反馈
      },
      rules:{
        
      },
      toolsOptions:[],
      restData:null
    };
  },
  computed: {},
  mounted(){
    this.getToolsList()  // 工具列表
    this.getDetail()  // 获取系统登录配置
    
  },
  methods: {
    // 删除工具批量操作工具
    // removeToolBatchOperation(name){
    //   this.form.batch.splice(this.form.batch.findIndex(item=>item==name),1)
    // },
    // 删除search批量操作工具
    removeSearchBatchOperation(name){
      this.form.recommend.splice(this.form.recommend.findIndex(item=>item==name),1)
    },
    // 获取详情
    getDetail(){
      toolUploadAPI.getDictDataListByType({typeId:2}).then(res=>{
        if(res.code==0){
          const loginData=res.data
          this.restData ={...res.data}
          this.form = loginData
          // this.form.batch = loginData.batch.map(item=>item.name)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 获取所有工具列表
    getToolsList(){
      toolsAPI.getAllToolsList().then(res=>{
        if(res.code==0){
          this.toolsOptions = res.data
        }
        else {
          this.$message.error(res.message)
        }
      })
    },
    // 取消
    cancel(){
      this.form = this.restData
      // if(JSON.stringify(this.restData.batch).includes('{')) {
      //   this.form.batch = this.form.batch.map(item=>item.name)
      // }
    },
    // 保存
    saveLoginType(){
      this.$refs.form.validate(valid=>{
        if(valid){
          const params = {...this.form}
        //   const batch = this.form.batch.map(item=>{
        //    if(this.toolsOptions.find(i=>i.name===item)){
        //     const findeValue = this.toolsOptions.find(i=>i.name===item)
        //     return {
        //       name:findeValue.name,
        //       name1:findeValue.frontInfo,
        //       id:findeValue.id
        //     }
        //    }
        //  })
        //   params.batch = batch
          toolUploadAPI.updateSysPublicConfig(params).then(res=>{
            if(res.code==0){
              this.$ebus.$emit('updateLeft')
              this.$message.success('保存成功')
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          return false
        }
      })
    },
  },

 
};
</script>

<style lang='less' scoped>
.login-config {
  padding: 20px;
  box-sizing: border-box;
  min-height: 95vh;
  .config-title {
    h3 {
      margin: 0px;
      padding: 0px;
      position: relative;
      padding-left: 15px;
      padding-bottom: 10px;
      &::before {
        content: '';
        width: 5px;
        height: 20px;
        background: #409EFF;
        position: absolute;
        left: 0px;
        top: 0px;
      }
    }
    .config-title-inline {
      margin: 0;
      margin-left: 15px;
      margin-bottom: 10px;
      border-top: 1px solid #ccc;
    }
  }
  .config-form {
    padding: 20px;
    box-sizing: border-box;
    .el-form-item {
      margin-bottom: 5px;
      margin-left: 15px;
      .el-checkbox-all {
        display: inline-flex;
      }
    }
  }
  .tag-show {
    .el-tag {
      margin-left: 10px;
    }
  }
  .config-title-banner {
    .el-textarea {
      width: 20%;
    }
    .el-col {
      display: flex;
      // margin-left: 10px;
      .el-textarea {
        // margin-left: 10px;
        width: 100%;
      }
    }
  }
  .config-btn {
    display: flex;
    justify-content: center;
    /deep/ .el-form-item__content {
      margin-left: 0px !important;
    }
  }
}
.tip {
  color: #AEAEAE;
  font-size: 12px;
  margin-left: 2vw;
  .setcolor {
    color: red;
  }
}
</style>